var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginCoinbase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 25.5C21.4706 25.5 25.5 21.4706 25.5 16.5C25.5 11.5294 21.4706 7.5 16.5 7.5C11.5294 7.5 7.5 11.5294 7.5 16.5C7.5 21.4706 11.5294 25.5 16.5 25.5Z",
    stroke: "#2159EB",
    strokeWidth: 6.95918
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2846 14.4048H14.7156C14.5442 14.4048 14.4053 14.5437 14.4053 14.7151V18.2841C14.4053 18.4555 14.5442 18.5944 14.7156 18.5944H18.2846C18.456 18.5944 18.5949 18.4555 18.5949 18.2841V14.7151C18.5949 14.5437 18.456 14.4048 18.2846 14.4048Z",
    fill: "#2159EB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCoinbase);
export default __webpack_public_path__ + "static/media/login-coinbase.f0042ebff35b15d2f4d405ae45da9e66.svg";
export { ForwardRef as ReactComponent };